import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SPLASHSCREENBLOCK_LEGACY_FIELD_ORDER = [
  "image",
  "link_url",
  "is_overlay",
  "background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  splashScreenBlockDescriptor: _generatedSplashScreenBlockDescriptor,
  splashScreenBlockBlocDefinition,
  splashScreenBlockDashboardLayout,
  splashScreenBlockConfig,
  splashScreenBlockResolveConfig,
  splashScreenBlockProperties,
} = doodBlockConfig(
  {
    name: "Splash screen",
    componentType: 'SplashScreenBlockComponent',
    category: 'content',
    description: "pages.blocks.splash-screen.description",
    keywords: [],
    allowedIn: [
      { bloc: '*Page', slot: '*' },
    ],
    sharedFields: {}
  },

  () => ({
    image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.splash-screen.image.label",
        help: "pages.blocks.splash-screen.image.help",
      }
    }),
    link_url: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.splash-screen.link-url.label",
        help: "pages.blocks.splash-screen.link-url.help",
      }
    }),
    is_overlay: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.splash-screen.is-overlay.label",
        help: "pages.blocks.splash-screen.is-overlay.help",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.splash-screen.background-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.splash-screen.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.splash-screen.fieldset.display.label",
            fields: [
              "image",
              "is_overlay",
              { prop: "background_color", visibleWhen: { is_overlay: true } },
              "link_url",
            ],
          },
        ],
      },
    ],
  })
);

export function splashScreenBlockDescriptor(): IBlockDescriptor;
export function splashScreenBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function splashScreenBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSplashScreenBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSplashScreenBlockDescriptor, splashScreenBlockProperties, fieldOrder);
}

export {
  splashScreenBlockBlocDefinition,
  splashScreenBlockDashboardLayout,
  splashScreenBlockProperties,
  splashScreenBlockConfig,
  splashScreenBlockResolveConfig,
};

export type SplashScreenBlockConfig = typeof splashScreenBlockConfig;
